import Vue from 'vue';

import Notifications from 'vue-notification';
import BootstrapVue from 'bootstrap-vue';
import VueProgressBar from 'vue-progressbar';

import App from './App.vue';
import router from './router';
import AxiosService from './common/services/axios.service';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';


AxiosService.init();
Vue.config.productionTip = false;
Vue.config.devtools = true;

Vue.use(BootstrapVue);
Vue.use(Notifications);
Vue.use(VueProgressBar, {
  color: '#4CAF50',
  failedColor: '#f44336',
  thickness: '4px',
});

export default new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
